<template>
  <div class="table-responsive">
    <div>
      <h4 class="service-response-h4">
        {{ $t("message.find_partner.common_info_cn") }}
      </h4>
    </div>
    <table class="table" :style="{ width: '100%' }">
      <thead>
        <tr>
          <th scope="col">{{ $t("message.find_partner.table_field") }}</th>
          <th scope="col">{{ $t("message.find_partner.table_value") }}</th>
          <th scope="col">{{ $t("message.find_partner.table_value_cn") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(value, index) in service_info"
          v-if="
            value[0] !== 'OperId' &&
            value[0] !== 'KeyNo' &&
            value[0] !== 'CreditCode'
          "
        >
          <td style="max-width: 150px">
            {{ $t("message.find_partner.common_info_" + value[0]) }}
          </td>
          <td v-if="value[0] == 'ImageUrl'">
            <img :src="value[2]" :alt="value[2]" style="max-width: 100px" />
          </td>
          <td v-if="value[0] == 'ImageUrl'">
            <img :src="value[2]" :alt="value[2]" style="max-width: 100px" />
          </td>
          <td v-if="value[0] == 'WebSiteUrl'">
            <a target="_blank" :href="prepareURL(value[2])">{{
              $t("message.find_partner.visit_company_website")
            }}</a>
          </td>
          <td v-if="value[0] == 'WebSiteUrl'">
            <a target="_blank" :href="prepareURL(value[2])">{{
              $t("message.find_partner.visit_company_website")
            }}</a>
          </td>
          <td
            v-if="value[0] !== 'WebSiteUrl' && value[0] !== 'ImageUrl'"
            style="max-width: 150px"
          >
            {{ value[2] }}

            <p v-if="value[0] === 'IXCode'">
              <br/>
              {{ $t("message.find_partner.common_info_IXCode_description") }}
            </p>
          </td>
          <td
            v-if="value[0] !== 'WebSiteUrl' && value[0] !== 'ImageUrl'"
            style="max-width: 150px"
          >
            {{ value[1] }}
          </td>
          <td v-if="value[0] == 'CreditCode'" style="max-width: 150px">
            {{ value[1] }}
          </td>
          <td v-if="value[0] == 'CreditCode'" style="max-width: 150px">
            {{ value[1] }}
          </td>
        </tr>
        <tr
          v-for="(value, index) in service_info"
          v-if="value[0] == 'CreditCode'"
        >
          <td style="max-width: 150px">
            {{ $t("message.find_partner.common_info_" + value[0]) }}
          </td>
          <td style="max-width: 150px">{{ value[1] }}</td>
          <td style="max-width: 150px">{{ value[1] }}</td>
        </tr>
      </tbody>
    </table>

    <div v-if="response_info.Area">
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.find_partner.area_table") }}
        </h4>
      </div>
      <b-table :fields="object_table_fields" :items="areaList">
        <template v-slot:cell(Key)="data">
          {{ $t("message.find_partner.area_list_" + data.value) }}
        </template>
      </b-table>
    </div>

    <div v-if="response_info.Industry">
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.find_partner.industry_table") }}
        </h4>
      </div>
      <b-table :fields="object_table_fields" :items="industryList">
        <template v-slot:cell(Key)="data">
          {{ $t("message.find_partner.industry_list_" + data.value) }}
        </template>
      </b-table>
    </div>
    <div v-if="response_info.RevokeInfo">
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.find_partner.revoke_info_table") }}
        </h4>
      </div>
      <b-table :fields="object_table_fields" :items="revokeInfoList">
        <template v-slot:cell(Key)="data">
          {{ $t("message.find_partner.revoke_info_list_" + data.value) }}
        </template>
      </b-table>
    </div>
    <div v-if="response_info.ParentInfo">
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.find_partner.parent_info_table") }}
        </h4>
      </div>
      <b-table :fields="object_table_fields" :items="parentInfoList">
        <template v-slot:cell(Key)="data">
          {{ $t("message.find_partner.parent_info_list_" + data.value) }}
        </template>
      </b-table>
    </div>

    <div v-if="UsedNameList.length > 0">
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.find_partner.common_info_name_list") }}
        </h4>
      </div>
      <b-table :fields="used_name_list_fields" :items="UsedNameList"> </b-table>
    </div>

    <div v-if="ShareHolderList.length > 0">
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.find_partner.common_info_share_holder_list") }}
        </h4>
      </div>
      <b-table :fields="shareholder_list_fields" :items="ShareHolderList">
      </b-table>
    </div>

    <div v-if="EmployeeList.length > 0">
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.find_partner.common_info_employee_list") }}
        </h4>
      </div>
      <b-table :fields="employees_list_fields" :items="EmployeeList"> </b-table>
    </div>

    <div v-if="InvestList.length > 0">
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.find_partner.common_info_invest_list") }}
        </h4>
      </div>
      <b-table :fields="invest_list_fields" :items="InvestList"> </b-table>
    </div>

    <div v-if="ChangeList.length > 0 && $route.name !== 'short-search'">
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.find_partner.common_info_change_list") }}
        </h4>
      </div>
      <b-table :fields="change_list_fields" :items="ChangeList"> </b-table>
    </div>

    <div v-if="BranchList.length > 0">
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.find_partner.common_info_branch_list") }}
        </h4>
      </div>
      <b-table :fields="branch_list_fields" :items="BranchList"> </b-table>
    </div>

    <div v-if="MoreEmailList.length > 0">
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.find_partner.common_info_more_email_list") }}
        </h4>
      </div>
      <b-table :fields="more_email_list_fields" :items="MoreEmailList">
      </b-table>
    </div>

    <div v-if="EntTagList.length > 0">
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.find_partner.common_info_ent_tag_list") }}
        </h4>
      </div>
      <b-table :fields="ent_tag_list_fields" :items="EntTagList"> </b-table>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["data", "mode"],
  data() {
    return {
      response_info: {},
      service_info: {},
      areaList: [],
      industryList: [],
      revokeInfoList: [],
      parentInfoList: [],

      UsedNameList: [],
      ShareHolderList: [],
      EmployeeList: [],
      InvestList: [],
      ChangeList: [],
      BranchList: [],
      MoreEmailList: [],
      EntTagList: [],
      used_name_list_fields: [
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_name_list_name"),
        },
        {
          key: "ChangeDate",
          label: this.$t("message.find_partner.common_info_name_list_date"),
        },
      ],
      shareholder_list_fields: [
        {
          key: "StockName",
          label: this.$t(
            "message.find_partner.common_info_share_holder_StockName",
          ),
        },
      ],
      employees_list_fields: [
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_employee_Name"),
        },
        {
          key: "Job",
          label: this.$t("message.find_partner.common_info_employee_Job"),
        },
      ],
      invest_list_fields: [
        {
          key: "RegistCapi",
          label: this.$t(
            "message.find_partner.common_info_invest_list_RegistCapi",
          ),
        },
        {
          key: "StartDate",
          label: this.$t(
            "message.find_partner.common_info_invest_list_StartDate",
          ),
        },
        {
          key: "Status",
          label: this.$t("message.find_partner.common_info_invest_list_Status"),
        },
        {
          key: "OperName",
          label: this.$t(
            "message.find_partner.common_info_invest_list_OperName",
          ),
        },
      ],
      change_list_fields: [
        {
          key: "ProjectName",
          label: this.$t(
            "message.find_partner.common_info_change_list_ProjectName",
          ),
        },
        {
          key: "BeforeList",
          label: this.$t(
            "message.find_partner.common_info_change_list_BeforeList",
          ),
        },
        {
          key: "AfterList",
          label: this.$t(
            "message.find_partner.common_info_change_list_AfterList",
          ),
        },
        {
          key: "ChangeDate",
          label: this.$t(
            "message.find_partner.common_info_change_list_ChangeDate",
          ),
        },
      ],
      branch_list_fields: [
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_branch_list_Name"),
        },
        {
          key: "DirectorName",
          label: this.$t(
            "message.find_partner.common_info_branch_list_DirectorName",
          ),
        },
        {
          key: "Status",
          label: this.$t("message.find_partner.common_info_branch_list_Status"),
        },
      ],
      more_email_list_fields: [
        {
          key: "Source",
          label: this.$t(
            "message.find_partner.common_info_more_email_list_Source",
          ),
        },
        {
          key: "Value",
          label: this.$t(
            "message.find_partner.common_info_more_email_list_Value",
          ),
        },
      ],
      more_tel_list_fields: [
        {
          key: "Source",
          label: this.$t(
            "message.find_partner.common_info_more_tel_list_Source",
          ),
        },
        {
          key: "Value",
          label: this.$t(
            "message.find_partner.common_info_more_tel_list_Value",
          ),
        },
      ],
      ent_tag_list_fields: [
        {
          key: "Type",
          label: this.$t("message.find_partner.common_info_ent_tag_list_Type"),
        },
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_ent_tag_list_Name"),
        },
      ],
      object_table_fields: [
        {
          key: "Key",
          label: this.$t("message.find_partner.table_field"),
        },
        {
          key: "Translated",
          label: this.$t("message.find_partner.table_value"),
        },
        {
          key: "Original",
          label: this.$t("message.find_partner.table_value_cn"),
        },
      ],
    };
  },
  mounted() {
    this.response_info = this.data.response_info;
    this.service_info = this.data.service_info;

    this.areaList = this.data.areaList;
    this.industryList = this.data.industryList;
    this.revokeInfoList = this.data.revokeInfoList;
    this.parentInfoList = this.data.parentInfoList;

    this.UsedNameList = this.data.UsedNameList;
    this.ShareHolderList = this.data.ShareHolderList;
    this.EmployeeList = this.data.EmployeeList;
    this.InvestList = this.data.InvestList;
    this.ChangeList = this.data.ChangeList;
    this.BranchList = this.data.BranchList;
    this.MoreEmailList = this.data.MoreEmailList;
    this.EntTagList = this.data.EntTagList;
  },
  computed: {},
  watch: {
    data: function (newVal, oldVal) {
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
      this.response_info = newVal.response_info;
      this.service_info = newVal.service_info;
      this.areaList = newVal.areaList;
      this.industryList = newVal.industryList;
      this.revokeInfoList = newVal.revokeInfoList;
      this.parentInfoList = newVal.parentInfoList;

      this.UsedNameList = newVal.UsedNameList;
      this.ShareHolderList = newVal.ShareHolderList;
      this.EmployeeList = newVal.EmployeeList;
      this.InvestList = newVal.InvestList;
      this.ChangeList = newVal.ChangeList;
      this.BranchList = newVal.BranchList;
      this.MoreEmailList = newVal.MoreEmailList;
      this.EntTagList = newVal.EntTagList;
    },
  },
  methods: {
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    /**
     * Checks if the string is correct URL and tries to fix if it is not
     * @param {*} string
     */
    prepareURL(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return "https://" + string;
      }
      return string;
    },
  },
};
</script>
